/**
 * Defines how a facet is displayed to the user.
 */
export enum FacetAppearance {
  Checkboxes = 'checkboxes',
  Swatches = 'swatches',
  Links = 'links',
  ToggleButtons = 'toggle-buttons'
}
